import { useState } from "react";
import { Button, Thumbnail } from "@shopify/polaris";
import { DeleteIcon, ProductIcon } from "@shopify/polaris-icons";
import { ProductObj } from "../../apps/Bundles/Types";
import CustomModal from "../CustomModal/CustomModal";

interface CollectionProductSelectorProps {
    collectionIds: string[];
    selectedProducts: ProductObj[];
    onProductsChange: (products: ProductObj[]) => void;
}

const CollectionProductSelector = ({
    collectionIds,
    selectedProducts,
    onProductsChange,
}: CollectionProductSelectorProps) => {
    const [showProductModal, setShowProductModal] = useState(false);

    const getNumericIdFromGid = (gid?: string): string | null => {
        if (!gid) return null;
        return gid.split("/").pop() ?? null;
    };

    const numericCollectionIds = collectionIds
        .map((id) => getNumericIdFromGid(id))
        .filter((id): id is string => id !== null);

    const handleProductSearch = async () => {
        if (numericCollectionIds.length === 0) {
            console.error("Collection IDs are required");
            return;
        }

        const preSelected = selectedProducts?.map((product: ProductObj) => ({
            id: product?.id,
            // variants: product?.variants.map((variant: any) => ({
            //     id: variant?.id,
            // })),
        }));

        try {
            const selected = await shopify.resourcePicker({
                type: "product",
                multiple: true,
                action: "select",
                selectionIds: preSelected,
                filter: {
                    query: `status:active AND published_status:published AND ${numericCollectionIds.map((id) => `collection_id:${id}`)?.join(" OR ")}`,
                    variants: false,
                },
            });

            if (selected) {
                const productsArr: any[] = [];
                selected?.flatMap((product: any) => {
                    productsArr.push({
                        id: product?.id,
                        images: product?.images,
                        title: product?.title,
                        handle: product?.handle,
                        // quantity: 1,
                        // maxProductStock: product?.totalInventory,
                        // selectedVariants: [],
                        // subscriptions: [],
                        // oneTimePurchase: true,
                        // isSubscribed: false,
                        // variants: product?.variants?.map((variant: VariantsObj) => ({
                        //     image: { ...variant.image },
                        //     id: variant?.id,
                        //     displayName: variant.displayName,
                        //     title: variant?.title?.toLowerCase() == "default title" ? product?.title : variant?.title,
                        //     price: variant?.price,
                        //     quantity: 1,
                        //     selectedOptions: variant?.selectedOptions,
                        //     copyPrice: variant.price,
                        //     compareAtPrice: variant?.compareAtPrice ? variant.compareAtPrice : variant.price,
                        // })),
                        // options: product?.options,
                    });
                });

                onProductsChange(productsArr);
            }
        } catch (error) {
            console.error("Error selecting products from collection:", error);
        }
    };

    const handleProductDelete = (productId: string) => {
        const updatedProducts = selectedProducts.filter((p: ProductObj) => p.id !== productId);
        onProductsChange(updatedProducts);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                padding: "5px",
                borderRadius: "8px",
                backgroundColor: "#f9f9f9",
            }}
        >
            <div
                style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                }}
            >
                <Button onClick={handleProductSearch}>Select Products</Button>
                <p
                    style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        color: "#007ace",
                        minWidth: "80px",
                    }}
                    onClick={() => setShowProductModal(true)}
                >
                    {selectedProducts.length} selected
                </p>
            </div>

            <CustomModal
                title={""}
                open={showProductModal}
                onClose={() => setShowProductModal(false)}
                secondaryActions={[
                    {
                        content: "Close",
                        onAction: () => setShowProductModal(false),
                    },
                ]}
                primaryAction={{
                    content: selectedProducts?.length > 0 ? "Edit Products" : "Add Products",
                    onAction: () => {
                        handleProductSearch();
                    },
                }}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "10px" }}>
                    {selectedProducts?.length > 0 ? (
                        selectedProducts.map((product: ProductObj) => (
                            <div
                                key={product.id}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "8px 12px",
                                    borderBottom: "1px solid #eee",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center",
                                    }}
                                >
                                    <Thumbnail
                                        source={product?.images?.[0]?.originalSrc || ProductIcon}
                                        alt={product?.images?.[0]?.altText || ""}
                                        size={"small"}
                                    />
                                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                        <span>{product.title}</span>
                                    </div>
                                </div>

                                <Button
                                    onClick={() => handleProductDelete(product.id)}
                                    icon={DeleteIcon}
                                    variant="plain"
                                    tone="critical"
                                    accessibilityLabel="Delete"
                                ></Button>
                            </div>
                        ))
                    ) : (
                        <p style={{ textAlign: "center", padding: "20px", color: "#666" }}>No products added.</p>
                    )}
                </div>
            </CustomModal>
        </div>
    );
};

export default CollectionProductSelector;
